export const environment = {
    // test: "http://192.168.8.17:4080/deviceConfig/",
    // test:"http://192.168.1.82:4080/deviceConfig/",
    test:"https://ilens.io/ilensiotsetupDevEnv/deviceConfig/" 
}